import * as Sentry from '@sentry/react';
import React, { useState } from 'react';
import requestService from '../../services/request.service';
import { ConsentPanelStatus, SoftConsentPanel } from '../portal/consentPanels';

type Props = {
  requestId: string;
  validationCode: string | number;
  patientConsentId: string;
  consent: { title: string; url: string | null };
  language: 'en' | 'es';
  primaryColor: string;
  prMap?: { [key: string]: string };
  remainingSteps?: number[];
  alreadyComplete?: boolean;
  onComplete: () => void;
};

/**
 * `/requests/:id` consent step. Drives the shared SoftConsentPanel via
 * the validationCode-keyed `requestService.submitConsent`.
 */
const StepConsent: React.FC<Props> = ({
  requestId,
  validationCode,
  patientConsentId,
  consent,
  language,
  primaryColor,
  prMap,
  remainingSteps,
  alreadyComplete,
  onComplete,
}) => {
  const [status, setStatus] = useState<ConsentPanelStatus>(alreadyComplete ? 'submitted' : 'ready');

  const handleSubmit = async (signature: string) => {
    if (!consent.url) return;

    setStatus('submitting');

    try {
      await requestService.submitConsent({
        requestId,
        patientConsentId,
        consentUrl: consent.url,
        signature,
        validationCode,
        prMap,
        remainingSteps,
      });
      setStatus('submitted');
    } catch (err) {
      Sentry.captureException(err);
      setStatus('error');
    }
  };

  return (
    <SoftConsentPanel
      title={consent.title}
      url={consent.url}
      primaryColor={primaryColor}
      language={language}
      status={status}
      onSubmit={handleSubmit}
      onExit={onComplete}
      exitLabel={language === 'es' ? 'Continuar' : 'Continue'}
    />
  );
};

export default StepConsent;
